import { get_req } from "../../Utilities/apiUtil";
import { get_all_streets_by_city_url } from "../../Utilities/apiUrl";

export const fetchStreetOptions = async (city) => {
  let streets = [];
  if (city) {
    try {
      const data = await get_req(`${get_all_streets_by_city_url}&city=${city}`);
      if (data.isValid) {
        streets = data.payload.map((p) => p.street_name) || [];
      }
    } catch (error) {
      console.log("Error fetching streets", error);
    }
  }
  return streets;
};
